import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { guides } from "@/data/guides";

export default function Guides() {
  return (
    <section id="guides" className="py-24 lg:py-32 px-6 lg:px-12 max-w-7xl mx-auto" data-testid="guides-section">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-16"
      >
        <div>
          <p className="font-sub text-xs sm:text-sm uppercase tracking-[0.2em] font-bold text-terra mb-4">Le blog</p>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.1] tracking-tight">
            Nos guides <em className="italic text-terra">gratuits</em>
          </h2>
        </div>
        <a
          href="#newsletter"
          data-testid="guides-see-all"
          className="group inline-flex items-center gap-2 font-sub text-sm uppercase tracking-[0.15em] text-ink/70 hover:text-terra transition-colors duration-200"
        >
          Recevoir les nouveaux guides
          <ArrowUpRight className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </a>
      </motion.div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {guides.map((g, i) => (
          <motion.div
            key={g.slug}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
          >
            <Link to={`/guides/${g.slug}`} className="group block" data-testid={`guide-card-${i + 1}`}>
              <div className="rounded-xl overflow-hidden border border-border mb-6 shadow-soft">
                <img
                  src={g.img}
                  alt={g.title}
                  className="w-full aspect-[4/3] object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <p className="font-sub text-xs uppercase tracking-[0.2em] font-bold text-terra mb-2">{g.category}</p>
              <h3 className="font-display text-xl sm:text-2xl leading-snug mb-3 group-hover:text-terra transition-colors duration-200">
                {g.title}
              </h3>
              <span className="font-sub text-sm text-ink/60 inline-flex items-center gap-1.5">
                Lire la suite
                <ArrowUpRight className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </span>
            </Link>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
